const requestDataType = 'REQUEST_CLIMACONTROL';
const receiveDataType = 'RECEIVE_CLIMACONTROL';
const receiveSetDataType = 'RECEIVESET_CLIMACONTROL';
const initialState = { email: '', mobile: '', phrase: '', metricCO2: 0, result: '', isLoading: false };
//const initialState = {  result: '', isLoading: false };

export const actionCreators = {
    getAlertData: () => async (dispatch, getState) => {
        //if (mobile === getState().climaControl.mobile) {
        //    // Don't issue a duplicate request (we already have or are loading the requested data)
        //    return;
        //}

        dispatch({ type: requestDataType });

        const url = `api/ClimaControl/GetAlertData`;
        
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                //"X-IOT-EXTEND": phrase
            }});
        
        const result = await response.json();
        console.log(`getAlertData - Response: ${result.code}`);

        const email = result.email;
        const mobile = result.mobile;

        dispatch({ type: receiveDataType, email, mobile, result });
        return result;
    },

    setAlertData: (email, mobile, phrase, metricTemperature, metricHumidity, metricDustDensity, metricCO2) => async (dispatch, getState) => {
        //if (mobile === getState().climaControl.mobile) {
        //    // Don't issue a duplicate request (we already have or are loading the requested data)
        //    return;
        //}
        if (phrase === undefined || phrase === "" || phrase === null) {
            dispatch({ type: "nophrase", result: { code: -1, message: "Passphrase is empty." } });
            return { code: -1, message: "Passphrase is empty." };
        }
        console.log("Mobile: " + getState().climaControl.mobile);
        console.log(`setAlertData - pre-Req: ${email} - ${mobile} - ${phrase}`);
        dispatch({ type: requestDataType, mobile });

        //const url = `api/ClimaControl/SetAlertData?email=${encodeURIComponent(email)}&mobile=${encodeURIComponent(mobile)}&phrase=${encodeURIComponent(phrase)}`;
        const url = `api/ClimaControl/SetAlertData?email=${encodeURIComponent(email)}&mobile=${encodeURIComponent(mobile)}&metricTemperature=${encodeURIComponent(metricTemperature)}&metricHumidity=${encodeURIComponent(metricHumidity)}&metricDustDensity=${encodeURIComponent(metricDustDensity)}&metricCO2=${encodeURIComponent(metricCO2)}`;
        
        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "X-IOT-EXTEND": encodeURIComponent(phrase)
            }});
        
        const result = await response.json();
        console.log(`setAlertData - Response: ${result.code}`);

        dispatch({ type: receiveSetDataType, mobile, result });
        return result;
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestDataType) {
        return {
            ...state,
            mobile: action.mobile,
            phrase: action.phrase,
            isLoading: true
        };
    }

    if (action.type === receiveDataType) {
        return {
            ...state,
            email: action.result.email,
            mobile: action.result.mobile,
            metricCO2: action.result.metricCO2,
            metricTemperature: action.result.metricTemperature,
            metricHumidity: action.result.metricHumidity,
            metricDustDensity: action.result.metricDustDensity,
            result: action.result,
            isLoading: false
        };
    }

    if (action.type === receiveSetDataType) {
        return {
            ...state,
            email: action.result.email,
            mobile: action.mobile, // action.mobile.substr(0, 6) + "xxxxx" + action.mobile.substr(11),
            metricCO2: action.result.metricCO2,
            metricTemperature: action.result.metricTemperature,
            metricHumidity: action.result.metricHumidity,
            metricDustDensity: action.result.metricDustDensity,
            phrase: "",
            result: action.result,
            isLoading: false
        };
    }

    if (action.type === "nophrase") {
        return {
            ...state,
            result: action.result,
            isLoading: false
        }
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/store/ClimaControl.js